/**
 * Combines the server-side E2E probe (independent of the operator's own
 * DNS cache) with the existing browser probe into one verdict for the
 * E2eProbe display (TASK-116).
 *
 * The server result wins: a stale DNS cache on the operator's machine or
 * router must not turn an actually-working chain red, and a real server
 * failure must not be hidden by a lucky browser cache hit.
 */

export interface ServerProbeResult {
  ok: boolean;
  detail: string;
}

export interface BrowserProbeResult {
  state: "ok" | "fail";
  detail: string;
}

export interface CustomHostnameE2eVerdict {
  state: "ok" | "fail";
  detail: string;
  hint?: string;
}

export const DNS_CACHE_HINT =
  "Von unserem Server aus erreichbar. Dein Browser sieht noch einen alten DNS-Eintrag (Cache deines Rechners/Routers) — löst sich von allein, sobald der alte Eintrag abläuft.";

export function resolveCustomHostnameE2eVerdict(
  server: ServerProbeResult,
  browser: BrowserProbeResult,
): CustomHostnameE2eVerdict {
  if (!server.ok) return { state: "fail", detail: server.detail };
  if (browser.state === "fail") {
    return { state: "ok", detail: server.detail, hint: DNS_CACHE_HINT };
  }
  return { state: "ok", detail: browser.detail };
}
